/* eslint-disable */
import { useState, useEffect, useRef } from "react";
import {
  auth, db, storage, uploadFile, loadGoogleMaps,
  collection, addDoc, serverTimestamp, onSnapshot, query, orderBy, limit, Timestamp, doc, getDoc,
  updateDoc, increment, writeBatch,
  signInWithEmailAndPassword, createUserWithEmailAndPassword,
} from "./firebase";
import {
  TEAL,GOLD,GREEN,RED,WARN,BG,WHITE,TEXT,SUB,LIGHT,DC,
  Btn,Inp,Card,Bar,Wrap,Sec,Tag,TabBar,Empty,InterestTags,
  formatDate,formatTime,formatDateTime,
} from "./components";

const shareCommunityPost=p=>{
  const origin=(typeof window!=="undefined"&&window.location?.origin)?window.location.origin:"https://8go.ca";
  const postUrl=`${origin}/?screen=community&post=${encodeURIComponent(p.id||"")}`;
  const raw=(p.text||"").replace(/\s+/g," ").trim();
  const line=raw.length>180?`${raw.substring(0,180)}…`:raw;
  const summary=`【八達Go 社區】${p.authorName||"用戶"}：${line||"（附圖）"}`;
  const payload={title:"八達Go · 社區動態",text:summary,url:postUrl};
  const fallback=()=>{
    const blob=`${summary}\n${postUrl}`;
    if(navigator.clipboard?.writeText){
      navigator.clipboard.writeText(blob).then(()=>alert("已複製內容同網址，可貼去 WhatsApp／WeChat")).catch(()=>{window.prompt("複製以下內容：",blob);});
    }else{
      window.prompt("複製以下內容：",blob);
    }
  };
  if(typeof navigator!=="undefined"&&navigator.share){
    navigator.share(payload).catch(()=>fallback());
  }else{
    fallback();
  }
};

/** 讚（每用戶一個 like 文檔，可取消） */
const PostLike=({postId,user,likesFromPost=0})=>{
  const [liked,setLiked]=useState(false);
  const [busy,setBusy]=useState(false);

  useEffect(()=>{
    if(!user?.uid){setLiked(false);return;}
    getDoc(doc(db,"community_posts",postId,"likes",user.uid)).then(s=>setLiked(s.exists()));
  },[user?.uid,postId]);

  const countDisplay=typeof likesFromPost==="number"?likesFromPost:0;

  const toggle=async()=>{
    if(!user){alert("請先登入乘客或車主帳戶");return;}
    if(busy)return;
    setBusy(true);
    try{
      const likeRef=doc(db,"community_posts",postId,"likes",user.uid);
      const postRef=doc(db,"community_posts",postId);
      const batch=writeBatch(db);
      if(liked){
        batch.delete(likeRef);
        batch.update(postRef,{likes:increment(-1)});
      }else{
        batch.set(likeRef,{uid:user.uid,createdAt:serverTimestamp()});
        batch.update(postRef,{likes:increment(1)});
      }
      await batch.commit();
      setLiked(!liked);
    }catch(e){alert("讚失敗："+e.message);}
    setBusy(false);
  };

  return(
    <button type="button" onClick={toggle} disabled={busy}
      style={{
        flex:1,display:"flex",alignItems:"center",justifyContent:"center",gap:6,
        background:liked?TEAL+"18":DC,border:`1px solid ${liked?TEAL:LIGHT}`,borderRadius:12,
        padding:"10px 8px",fontSize:16,fontWeight:700,color:liked?TEAL:TEXT,cursor:busy?"wait":"pointer",
      }}>
      <span style={{fontSize:22,lineHeight:1}}>👍</span>
      <span>{liked?"已讚":"讚好"}</span>
      {countDisplay>0&&<span style={{color:SUB,fontWeight:600}}>{countDisplay}</span>}
    </button>
  );
};

/** 單帖留言區（摺疊、即時 sync） */
const PostComments=({postId,user,userName,userAvatar,commentCount=0})=>{
  const [open,setOpen]=useState(false);
  const [comments,setComments]=useState([]);
  const [text,setText]=useState("");
  const [sending,setSending]=useState(false);

  useEffect(()=>{
    if(!open)return;
    const q=query(collection(db,"community_posts",postId,"comments"),orderBy("createdAt","asc"));
    const unsub=onSnapshot(q,snap=>{
      setComments(snap.docs.map(d=>({id:d.id,...d.data()})));
    });
    return()=>unsub();
  },[open,postId]);

  const send=async()=>{
    const t=text.trim();
    if(!t||!user||sending)return;
    if(t.length>500){alert("留言太長（最多500字）");return;}
    setSending(true);
    try{
      const cref=doc(collection(db,"community_posts",postId,"comments"));
      const batch=writeBatch(db);
      batch.set(cref,{
        uid:user.uid,
        authorName:userName||"匿名用戶",
        authorAvatar:userAvatar||null,
        text:t,
        createdAt:serverTimestamp(),
      });
      batch.update(doc(db,"community_posts",postId),{commentCount:increment(1)});
      await batch.commit();
      setText("");
    }catch(e){alert("留言失敗："+e.message);}
    setSending(false);
  };

  const n=open?comments.length:Math.max(commentCount||0,0);

  return(
    <div style={{marginTop:12,borderTop:`1px solid ${LIGHT}`,paddingTop:10}}>
      <button type="button" onClick={()=>setOpen(o=>!o)}
        style={{width:"100%",textAlign:"left",background:DC,border:`1px solid ${LIGHT}`,borderRadius:10,
          padding:"10px 12px",fontSize:16,fontWeight:700,color:TEAL,cursor:"pointer"}}>
        💬 {open?"收起留言":"睇留言"} {n>0?`（${n}）`:""}
      </button>
      {open&&(
        <div className="go-fade" style={{marginTop:10}}>
          {comments.length===0?(
            <p style={{color:SUB,fontSize:15,margin:"8px 0"}}>暫時冇留言，做第一個回覆！</p>
          ):(
            <div style={{display:"flex",flexDirection:"column",gap:10}}>
              {comments.map(c=>(
                <div key={c.id} style={{display:"flex",gap:10,alignItems:"flex-start",
                  background:WHITE,border:`1px solid ${LIGHT}`,borderRadius:12,padding:10}}>
                  <div style={{width:32,height:32,borderRadius:"50%",background:DC,overflow:"hidden",
                    flexShrink:0,display:"flex",alignItems:"center",justifyContent:"center",fontSize:15}}>
                    {c.authorAvatar?<img src={c.authorAvatar} style={{width:"100%",height:"100%",objectFit:"cover"}} alt=""/>:"👤"}
                  </div>
                  <div style={{flex:1,minWidth:0}}>
                    <div style={{display:"flex",flexWrap:"wrap",alignItems:"baseline",gap:6,marginBottom:4}}>
                      <span style={{color:TEXT,fontWeight:700,fontSize:15}}>{c.authorName||"匿名"}</span>
                      <span style={{color:SUB,fontSize:13}}>{formatDateTime(c.createdAt)}</span>
                    </div>
                    <p style={{color:TEXT,fontSize:16,lineHeight:1.55,margin:0,whiteSpace:"pre-wrap"}}>{c.text}</p>
                  </div>
                </div>
              ))}
            </div>
          )}
          {user?(
            <div style={{marginTop:12}}>
              <textarea value={text} onChange={e=>setText(e.target.value)} placeholder="寫低你嘅回覆…"
                style={{width:"100%",background:DC,border:`1.5px solid ${LIGHT}`,borderRadius:12,
                  padding:"10px 12px",fontSize:16,color:TEXT,outline:"none",resize:"none",minHeight:72,lineHeight:1.5}}/>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginTop:8}}>
                <span style={{color:SUB,fontSize:14}}>{text.length}/500</span>
                <Btn label={sending?"送出中…":"發表留言"} color={text.trim()?TEAL:"#CBD5E1"}
                  disabled={!text.trim()||sending} onClick={send}/>
              </div>
            </div>
          ):(
            <p style={{color:SUB,fontSize:15,marginTop:12}}>登入乘客／車主帳戶後可參與討論。</p>
          )}
        </div>
      )}
    </div>
  );
};

const CATEGORIES=[
  {key:"all",icon:"📰",label:"全部"},
  {key:"traffic",icon:"🚦",label:"路況"},
  {key:"gas",icon:"⛽",label:"油價"},
  {key:"community",icon:"🏘️",label:"社區"},
  {key:"tips",icon:"💡",label:"實用"},
];

const OPENVAN_FUEL_URL="https://openvan.camp/api/fuel/prices";

const geoCountryFromResults=results=>{
  if(!results||!results[0])return{code:"CA",name:"Canada"};
  const ac=results[0].address_components||[];
  for(let i=0;i<ac.length;i++){
    if(ac[i].types?.includes("country"))
      return{code:ac[i].short_name||"CA",name:ac[i].long_name||""};
  }
  return{code:"CA",name:"Canada"};
};

const geoLocalLabel=results=>{
  if(!results||!results[0])return"";
  const ac=results[0].address_components||[];
  let city="",prov="";
  for(let i=0;i<ac.length;i++){
    if(ac[i].types?.includes("locality"))city=ac[i].long_name;
    if(ac[i].types?.includes("administrative_area_level_1"))prov=ac[i].short_name;
  }
  if(city&&prov)return`${city} · ${prov}`;
  if(city)return city;
  if(prov)return prov;
  const fa=results[0].formatted_address||"";
  return fa.split(",").slice(0,2).join(" · ").trim();
};

const Community=({onBack,focusPostId=""})=>{
  const [posts,setPosts]=useState([]);
  const [cat,setCat]=useState("all");
  const [highlightedPostId,setHighlightedPostId]=useState("");
  const [showCompose,setShowCompose]=useState(false);
  const [newText,setNewText]=useState("");
  const [newCat,setNewCat]=useState("community");
  const [newPhoto,setNewPhoto]=useState(null);
  const [newPhotoPreview,setNewPhotoPreview]=useState(null);
  const [posting,setPosting]=useState(false);
  const [user,setUser]=useState(null);
  const [userName,setUserName]=useState("");
  const [userAvatar,setUserAvatar]=useState(null);
  const fileRef=useRef(null);
  const postRefs=useRef({});

  const [gasLoading,setGasLoading]=useState(false);
  const [gasErr,setGasErr]=useState("");
  const [gasPlace,setGasPlace]=useState("");
  const [gasRow,setGasRow]=useState(null);
  const [gasUsedFallback,setGasUsedFallback]=useState(false);

  const loadGasFromLocation=()=>{
    setGasErr("");
    if(!navigator.geolocation){
      setGasErr("你嘅瀏覽器唔支援定位。");
      return;
    }
    setGasLoading(true);
    setGasRow(null);
    setGasUsedFallback(false);
    navigator.geolocation.getCurrentPosition(
      async pos=>{
        const lat=pos.coords.latitude;
        const lng=pos.coords.longitude;
        try{
          await loadGoogleMaps();
          const gc=new window.google.maps.Geocoder();
          gc.geocode({location:{lat,lng}},async(results,status)=>{
            try{
              if(status!=="OK"||!results?.[0]){
                setGasPlace(`${lat.toFixed(3)}, ${lng.toFixed(3)}`);
                await fetchAndSetGas("CA",true);
                return;
              }
              const {code,name}=geoCountryFromResults(results);
              setGasPlace(geoLocalLabel(results)||name||`${lat.toFixed(3)}, ${lng.toFixed(3)}`);
              await fetchAndSetGas(code,false);
            }finally{
              setGasLoading(false);
            }
          });
        }catch(e){
          setGasErr("地圖服務載入失敗，請稍後再試。");
          setGasLoading(false);
        }
      },
      ()=>{
        setGasErr("請允許定位權限，並確認 GPS 已開啟。");
        setGasLoading(false);
      },
      {enableHighAccuracy:true,timeout:18000,maximumAge:120000}
    );
  };

  const fetchAndSetGas=async(countryCode,forceCanada)=>{
    try{
      const res=await fetch(OPENVAN_FUEL_URL);
      const json=await res.json();
      if(!json.success||!json.data)throw new Error("油價資料暫時無法讀取");
      let row=json.data[countryCode];
      let usedFb=false;
      if(!row){
        if(forceCanada||countryCode==="CA"){
          row=json.data.CA;
          usedFb=!!row&&countryCode!=="CA";
        }
      }
      if(!row)throw new Error(`暫無「${countryCode}」嘅公開參考油價`);
      setGasRow(row);
      setGasUsedFallback(!!usedFb);
    }catch(e){
      setGasErr(e.message||"載入失敗");
      setGasRow(null);
    }
  };

  // Check auth
  useEffect(()=>{
    const unsub=auth.onAuthStateChanged(async u=>{
      if(u){
        setUser(u);
        // Try passenger profile first, then driver
        try{
          let snap=await getDoc(doc(db,"passengers",u.uid));
          if(snap.exists()){
            setUserName(snap.data().name||"");
            setUserAvatar(snap.data().avatarURL||null);
            return;
          }
          snap=await getDoc(doc(db,"drivers",u.uid));
          if(snap.exists()){
            setUserName(snap.data().name||"");
            setUserAvatar(snap.data().selfieURL||null);
          }
        }catch(e){}
      }
    });
    return()=>unsub();
  },[]);

  // Listen to posts
  useEffect(()=>{
    const q=query(collection(db,"community_posts"),orderBy("createdAt","desc"),limit(50));
    const unsub=onSnapshot(q,(snap)=>{
      setPosts(snap.docs.map(d=>({id:d.id,...d.data()})));
    });
    return()=>unsub();
  },[]);

  useEffect(()=>{
    if(!focusPostId||posts.length===0)return;
    const targetExists=posts.some(p=>p.id===focusPostId);
    if(!targetExists)return;
    if(cat!=="all"){
      setCat("all");
      return;
    }
    const el=postRefs.current[focusPostId];
    if(!el)return;
    el.scrollIntoView({behavior:"smooth",block:"center"});
    setHighlightedPostId(focusPostId);
    const t=setTimeout(()=>setHighlightedPostId(""),2600);
    return()=>clearTimeout(t);
  },[focusPostId,posts,cat]);

  const handlePhoto=e=>{
    const file=e.target.files[0];
    if(!file)return;
    setNewPhoto(file);
    const reader=new FileReader();
    reader.onload=ev=>setNewPhotoPreview(ev.target.result);
    reader.readAsDataURL(file);
  };

  const submitPost=async()=>{
    if(!newText.trim()||!user)return;
    setPosting(true);
    try{
      let photoURL=null;
      if(newPhoto){
        photoURL=await uploadFile(newPhoto,`community/${user.uid}/${Date.now()}`);
      }
      await addDoc(collection(db,"community_posts"),{
        uid:user.uid,
        authorName:userName||"匿名用戶",
        authorAvatar:userAvatar||null,
        text:newText.trim(),
        category:newCat,
        photoURL,
        likes:0,
        commentCount:0,
        createdAt:serverTimestamp(),
      });
      setNewText("");setNewCat("community");setNewPhoto(null);setNewPhotoPreview(null);
      setShowCompose(false);
    }catch(e){alert("發佈失敗："+e.message);}
    setPosting(false);
  };

  const filtered=cat==="all"?posts:posts.filter(p=>p.category===cat);

  const catIcon=c=>CATEGORIES.find(x=>x.key===c)?.icon||"📰";

  // ── COMPOSE ─────────────────────────────────────────────────────────
  if(showCompose)return(
    <div style={{minHeight:"100vh",background:BG}}>
      <Bar title="發佈動態" onBack={()=>setShowCompose(false)}/>
      <Wrap>
        {!user?(
          <Card style={{textAlign:"center",padding:24}}>
            <p style={{color:TEXT,fontWeight:600,marginBottom:8}}>請先登入</p>
            <p style={{color:SUB,fontSize:16}}>返回主頁以乘客或車主身份登入後，即可發佈社區動態。</p>
            <Btn label="返回主頁" color={TEAL} style={{marginTop:12}} onClick={onBack}/>
          </Card>
        ):(
          <>
            <Sec title="分類">
              <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
                {CATEGORIES.filter(c=>c.key!=="all").map(c=>(
                  <div key={c.key} onClick={()=>setNewCat(c.key)} style={{
                    padding:"8px 14px",borderRadius:20,fontSize:16,cursor:"pointer",
                    background:newCat===c.key?TEAL+"22":WHITE,
                    border:`1.5px solid ${newCat===c.key?TEAL:LIGHT}`,
                    color:newCat===c.key?TEAL:SUB,fontWeight:600}}>
                    {c.icon} {c.label}
                  </div>
                ))}
              </div>
            </Sec>

            <Sec title="內容">
              <Card>
                <textarea value={newText} onChange={e=>setNewText(e.target.value)}
                  placeholder={newCat==="traffic"?"分享你見到嘅路況，例如：401 East 塞車中 🚦":
                    newCat==="gas"?"邊間油站最平？分享油價資訊 ⛽":
                    "分享社區資訊、生活小貼士..."}
                  style={{width:"100%",background:DC,border:`1.5px solid ${LIGHT}`,borderRadius:12,
                    padding:"12px 14px",fontSize:17,color:TEXT,outline:"none",resize:"none",height:120,lineHeight:1.6}}/>
                <p style={{color:SUB,fontSize:14,textAlign:"right"}}>{newText.length}/500</p>
              </Card>
            </Sec>

            <Sec title="附相（選填）">
              <div style={{display:"flex",gap:12,alignItems:"center"}}>
                {newPhotoPreview?(
                  <div style={{position:"relative"}}>
                    <img src={newPhotoPreview} style={{width:80,height:80,borderRadius:12,objectFit:"cover"}} alt=""/>
                    <div onClick={()=>{setNewPhoto(null);setNewPhotoPreview(null);}}
                      style={{position:"absolute",top:-6,right:-6,background:RED,color:WHITE,
                        borderRadius:"50%",width:20,height:20,fontSize:15,display:"flex",
                        alignItems:"center",justifyContent:"center",cursor:"pointer"}}>✕</div>
                  </div>
                ):(
                  <div onClick={()=>fileRef.current?.click()}
                    style={{width:80,height:80,borderRadius:12,background:DC,border:`1.5px dashed ${LIGHT}`,
                      display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer",fontSize:24}}>
                    📷
                  </div>
                )}
                <input ref={fileRef} type="file" accept="image/*" onChange={handlePhoto} style={{display:"none"}}/>
                <p style={{color:SUB,fontSize:15}}>拍照或上載圖片</p>
              </div>
            </Sec>

            <Btn label={posting?"發佈中...":"📤 發佈"} color={newText.trim()?TEAL:"#CBD5E1"}
              disabled={!newText.trim()||posting} onClick={submitPost}/>
          </>
        )}
      </Wrap>
    </div>
  );

  // ── MAIN FEED ───────────────────────────────────────────────────────
  return(
    <div style={{minHeight:"100vh",background:BG}}>
      <Bar title="🏘️ 社區動態" onBack={onBack}
        right={<button onClick={()=>setShowCompose(true)}
          style={{background:TEAL,color:WHITE,border:"none",borderRadius:10,
            padding:"6px 14px",fontSize:16,fontWeight:700,cursor:"pointer"}}>✏️ 發佈</button>}/>

      {/* Category filter：兩行排列，避免橫向捲動漏睇分類 */}
      <div style={{padding:"10px 18px",background:WHITE,borderBottom:`1px solid ${LIGHT}`,display:"flex",flexDirection:"column",gap:8}}>
        <div style={{display:"flex",gap:8,justifyContent:"center",flexWrap:"wrap"}}>
          {CATEGORIES.slice(0,3).map(c=>(
            <div key={c.key} onClick={()=>setCat(c.key)} style={{
              flex:"1 1 0",minWidth:0,maxWidth:"33%",padding:"8px 6px",borderRadius:20,fontSize:15,cursor:"pointer",textAlign:"center",
              background:cat===c.key?TEAL:DC,color:cat===c.key?WHITE:SUB,fontWeight:600,lineHeight:1.35}}>
              {c.icon} {c.label}
            </div>
          ))}
        </div>
        <div style={{display:"flex",gap:8,justifyContent:"center",flexWrap:"wrap"}}>
          {CATEGORIES.slice(3).map(c=>(
            <div key={c.key} onClick={()=>setCat(c.key)} style={{
              flex:"1 1 0",minWidth:0,maxWidth:"50%",padding:"8px 6px",borderRadius:20,fontSize:15,cursor:"pointer",textAlign:"center",
              background:cat===c.key?TEAL:DC,color:cat===c.key?WHITE:SUB,fontWeight:600,lineHeight:1.35}}>
              {c.icon} {c.label}
            </div>
          ))}
        </div>
      </div>

      <Wrap>
        {cat==="gas"&&(
          <Card style={{background:"#FFFBEB",border:`1px solid ${GOLD}44`,marginBottom:14}}>
            <p style={{color:TEXT,fontWeight:800,fontSize:18,margin:"0 0 6px"}}>⛽ 參考油價（按你位置）</p>
            <p style={{color:SUB,fontSize:15,lineHeight:1.55,margin:"0 0 12px"}}>
              用<b> GPS 定位</b>判斷國家／地區，再顯示<b>公開 API</b>嘅平均價作參考。
              <b>唔係</b>你隔離油站嘅即時牌價；實際以油站為準。
            </p>
            <Btn label={gasLoading?"定位緊…":gasRow?"🔄 重新用定位更新":"📍 用我嘅位置查參考油價"}
              color={gasLoading?"#CBD5E1":WARN} textColor={WHITE}
              disabled={gasLoading} onClick={loadGasFromLocation} style={{marginBottom:10}}/>
            {gasErr&&<p style={{color:RED,fontSize:15,margin:"6px 0 0",lineHeight:1.45}}>{gasErr}</p>}
            {gasRow&&(
              <div style={{marginTop:12,background:WHITE,border:`1px solid ${LIGHT}`,borderRadius:12,padding:14}}>
                <p style={{color:SUB,fontSize:15,margin:"0 0 4px"}}>📍 {gasPlace||"—"}</p>
                {gasUsedFallback&&(
                  <p style={{color:WARN,fontSize:14,margin:"0 0 8px"}}>你所在國家／地區無獨立條目，改顯示加拿大參考價。</p>
                )}
                <p style={{color:TEXT,fontWeight:700,fontSize:17,margin:"8px 0 4px"}}>{gasRow.country_name||gasRow.country_code}</p>
                <p style={{color:SUB,fontSize:14,margin:"0 0 10px"}}>
                  單位：每{gasRow.unit==="liter"?"公升":"單位"} · 貨幣：{gasRow.local_currency||gasRow.currency||"—"}
                </p>
                {gasRow.prices?.gasoline!=null&&(
                  <p style={{color:TEXT,fontSize:18,margin:"6px 0",fontWeight:700}}>
                    汽油：<span style={{color:TEAL}}>{Number(gasRow.prices.gasoline).toFixed(2)}</span>{" "}
                    {gasRow.local_currency||gasRow.currency}/
                    {gasRow.unit==="liter"?"L":gasRow.unit==="gallon"?"gal":(gasRow.unit||"")}
                  </p>
                )}
                {gasRow.prices?.diesel!=null&&(
                  <p style={{color:TEXT,fontSize:17,margin:"4px 0"}}>
                    柴油：{Number(gasRow.prices.diesel).toFixed(2)} {gasRow.local_currency||gasRow.currency}/
                    {gasRow.unit==="liter"?"L":gasRow.unit==="gallon"?"gal":(gasRow.unit||"")}
                  </p>
                )}
                {gasRow.fetched_at&&(
                  <p style={{color:SUB,fontSize:13,margin:"12px 0 0",lineHeight:1.45}}>
                    資料更新：{gasRow.fetched_at}
                    {gasRow.sources?.length?` · ${gasRow.sources.slice(0,2).join("、")}`:""}
                  </p>
                )}
                <p style={{color:SUB,fontSize:13,margin:"8px 0 0",lineHeight:1.45}}>
                  來源：OpenVan.camp 公開 API（多國彙整，僅供參考）
                </p>
              </div>
            )}
          </Card>
        )}
        {filtered.length===0?(
          <Empty icon="📭" msg={cat==="gas"?"暫無油價貼文 — 可用上面參考價，或發佈你見到嘅油站價格！":"暫無動態，做第一個分享嘅人！"}/>
        ):(
          filtered.map(p=>(
            <div key={p.id} ref={el=>{if(el)postRefs.current[p.id]=el;}}>
              <Card style={highlightedPostId===p.id?{border:`2px solid ${TEAL}`,boxShadow:`0 0 0 3px ${TEAL}22`}:undefined}>
              <div style={{display:"flex",gap:10,alignItems:"center",marginBottom:10}}>
                <div style={{width:36,height:36,borderRadius:"50%",background:DC,overflow:"hidden",
                  display:"flex",alignItems:"center",justifyContent:"center",fontSize:18,border:`1px solid ${LIGHT}`,flexShrink:0}}>
                  {p.authorAvatar?<img src={p.authorAvatar} style={{width:"100%",height:"100%",objectFit:"cover"}} alt=""/>:"👤"}
                </div>
                <div style={{flex:1}}>
                  <p style={{color:TEXT,fontWeight:600,fontSize:16,margin:0}}>{p.authorName||"匿名"}</p>
                  <p style={{color:SUB,fontSize:14,margin:0}}>{formatDateTime(p.createdAt)}</p>
                </div>
                <Tag label={`${catIcon(p.category)} ${CATEGORIES.find(c=>c.key===p.category)?.label||""}`}
                  color={p.category==="traffic"?RED:p.category==="gas"?WARN:p.category==="tips"?GOLD:TEAL}/>
              </div>
              <p style={{color:TEXT,fontSize:17,lineHeight:1.6,margin:"0 0 8px",whiteSpace:"pre-wrap"}}>{p.text}</p>
              {p.photoURL&&(
                <img src={p.photoURL} style={{width:"100%",borderRadius:12,maxHeight:250,objectFit:"cover",marginBottom:8}} alt=""/>
              )}
              <div style={{display:"flex",gap:10,marginTop:4}}>
                <PostLike postId={p.id} user={user} likesFromPost={p.likes??0}/>
                <button type="button" onClick={()=>shareCommunityPost(p)}
                  style={{
                    flex:1,display:"flex",alignItems:"center",justifyContent:"center",gap:6,
                    background:DC,border:`1px solid ${LIGHT}`,borderRadius:12,
                    padding:"10px 8px",fontSize:16,fontWeight:700,color:TEXT,cursor:"pointer",
                  }}>
                  <span style={{fontSize:18}}>📤</span>分享
                </button>
              </div>
                <PostComments postId={p.id} user={user} userName={userName} userAvatar={userAvatar}
                  commentCount={p.commentCount||0}/>
              </Card>
            </div>
          ))
        )}
      </Wrap>
    </div>
  );
};

export default Community;
